import NotFound404Img from '@/assets/images/not-found-img.png';
import { ButtonCus } from '@/components/common/Button';
import { ekDomain } from '@/configs/constants';
import { ICON_IDS } from '@/constants/icon';
import { isPathEk } from '@/utils/routes';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useSearchParams } from 'react-router-dom';

export default function NotFoundPage() {
    const [searchParams] = useSearchParams();
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const isCancelled = searchParams.get('reason') === 'cancelled';
    const isEk = isPathEk(pathname);

    if (isCancelled) {
        return (
            <div className='container py-10'>
                <div className='w-full max-w-[420px] mx-auto flex flex-col items-center text-center'>
                    <svg height={96} width={96} className='text-[#D9001B]'>
                        <use href={ICON_IDS.DELETE}></use>
                    </svg>
                    <p className='text-fs-mid20 font-bold mt-6'>{t('messages.payment_link_cancelled_title')}</p>
                    <p className='text-text-3 whitespace-pre-line mt-4'>{t('messages.payment_link_cancelled_desc')}</p>
                    <Link to={isEk ? `/${ekDomain}/my-account` : '/my-account'} className='mt-8 w-full sm:w-auto'>
                        <ButtonCus
                            variant='default'
                            size='md'
                            className='w-full sm:w-[288px] bg-[#D9001B] border-[#D9001B] hoverable:hover:hover:text-[#D9001B]'
                        >
                            {t('button.back_to_mypage')}
                        </ButtonCus>
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className='container py-10'>
            <div className='w-1/2 max-w-[400px] mx-auto'>
                <div className='w-full h-full flex flex-col justify-center items-center'>
                    <img src={NotFound404Img} alt='Page not found' />
                </div>
            </div>
        </div>
    );
}
